import { z } from "zod";
export const listPropertiesQuerySchema = z.object({
    search: z.string().trim().min(1).optional(),
});
